import React from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { connect } from 'react-redux';
import { addMsg, removeMsg } from '../../../redux/actions/msg-actions';
import StaffActions from './StaffActions';
import { PERSONAL_URL } from '../../../config';

class StaffActionsContaienr extends React.Component {

    state = {
        showMenu: false,
        rejected_reason: '',
        opened: '',
        userModal: false,
        userError: '',
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            opened: nextProps.application.opened
        });
    }

    updateDealPipedrive = () => {
        const id = this.props.addMsg({ type: 'msg', text: 'Actualizando deal...'});
        axios.get('/api/v2/update-deal-pipedrive/')
            .then(() => {
                this.props.removeMsg(id);
                this.props.addMsg({ type: 'msg', text: 'Deal actualizado correctamente!' });
            });
    }

    requestInspection = () => {
        if(confirm("¿Estás seguro que querés realizar la inspección en Tecnored?")){
            axios.get('/api/tecnored/inspection/')
            .then((response) => {
                this.props.addMsg({ type: 'msg', text: response.data.msg });
            })
            .catch(({response}) => {
                this.props.addMsg({ type: 'msg', text: `¡ERROR! ${response.data.msg}`});
            });
        }
    }

    requestVeraz = () => {
        if(confirm("¿Estás seguro que querés realizar la consulta a Veraz?")){
            axios.get('/api/run-veraz/')
            .then((response) => {
                this.props.addMsg({ type: 'msg', text: response.data.msg });
            })
            .catch(({response}) => {
                this.props.addMsg({ type: 'msg', text: `¡ERROR! ${response.data.msg}`});
            });
        }
    }

    toggleMenu = () => {
        this.setState({ showMenu: !this.state.showMenu });
    }

    createUser = () => {
        if(confirm("¿Estás seguro que querés crear un usuario nuevo?")){
            axios.post('/api/v2/create-user/')
            .then(res =>{
                if(this.props.setUserTrue) this.props.setUserTrue()
            })
            .catch(({response}) => {
                this.props.addMsg({ type: 'msg', text: `¡ERROR! ${response.data.error}` });
            });
        }
    }

    closeUsermodal = () =>{
        this.setState({
            userModal: false,
        });
    }

    handleUserError = () =>{
        this.props.history.push(`${this.props.match.url}${PERSONAL_URL}`);
        this.setState({
            userModal: false,
        });
    }

    render() {
        const { app_type, has_user, application, } = this.props;

        return <StaffActions
                updateDealPipedrive={this.updateDealPipedrive}
                requestInspection={this.requestInspection}
                toggleMenu={this.toggleMenu}
                app_type={app_type}
                has_user={has_user}
                createUser={this.createUser}
                status={application.status}
                closeUsermodal={this.closeUsermodal}
                handleUserError={this.handleUserError}
                requestVeraz={this.requestVeraz}
                {...this.state}/>;
    }
}

const mapStateToProps = ({ user, application }) => ({ is_staff: !!user.is_staff, application: application.application });
const mapDispatchToProps = { addMsg, removeMsg }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StaffActionsContaienr));
